import moment from 'moment';
import { notification } from 'antd';
import { PersistentRepo } from '_src/shared/repo';

const transform = res => {
  const responseCode = res?.code;
  if (responseCode && responseCode !== 200 && responseCode !== 201) {
    notification.error({
      message: responseCode === 402 ? 'You do not have permission' : 'Something went wrong',
      duration: 5
    });

    return { data: [], total: 0 };
  }

  const getTimezone = PersistentRepo.get('getTimezone');
  const data = res?.data?.info?.studentInfos || [];

  const transformedData = data.map(item => {
    const rawSubmittedDate = item.submittedDate || item.submitted_date;

    return {
      ...item,
      submittedDate: rawSubmittedDate
        ? moment
            .tz(
              moment.parseZone(moment(rawSubmittedDate)).format('MM/DD/YYYY HH:mm'),
              'MM/DD/YYYY HH:mm',
              getTimezone
            )
            .format('MM/DD/YYYY HH:mm')
        : rawSubmittedDate
    };
  });

  return { data: transformedData, total: res.data.info.total };
};

export { transform };
